import React from "react";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="w-full px-4 py-6 sm:px-6">
      <div className="mx-auto max-w-4xl">
        <nav aria-label="Breadcrumb" className="mb-4">
          <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
            <Link
              to="/"
              className="font-medium transition-colors hover:text-slate-900 dark:hover:text-slate-100"
            >
              Lobby
            </Link>
            <span aria-hidden="true">/</span>
            <span className="font-medium text-slate-700 dark:text-slate-200">About</span>
          </div>
        </nav>

        <section className="overflow-hidden rounded-3xl border border-slate-200 bg-[linear-gradient(135deg,#fffaf0_0%,#ffffff_45%,#eff6ff_100%)] p-6 shadow-sm dark:border-slate-700 dark:bg-[linear-gradient(135deg,#1e293b_0%,#111827_48%,#172554_100%)] sm:p-8">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-amber-600 dark:text-amber-300">
            About
          </p>
          <h1 className="mt-3 text-3xl font-black tracking-tight text-slate-900 dark:text-slate-100 sm:text-4xl">
            Game for a Laugh
          </h1>
          <div className="mt-5 max-w-3xl space-y-4 text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
            <p>
              Game for a Laugh was created as a hobby for personal enjoyment and learning purposes. It grew out of a love of playing games with family and friends, and became a way to combine that with building software.
            </p>
            <p>
              The project is continuously evolving with new games, features, and improvements being added regularly.
            </p>
            <p>
              Many of these games are best played with people you know and so we encourage you to{' '}
              <button
                type="button"
                className="inline font-semibold text-blue-600 underline dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 focus:outline-none"
                style={{ padding: 0, background: 'none', border: 'none', cursor: 'pointer' }}
                onClick={() => {
                  window.dispatchEvent(new CustomEvent('open-share-modal'));
                }}
              >
                invite your friends and family
              </button>
              {' '}to join in the fun.
            </p>
            
              <p>Have a look at some of our <a href="/Games" className="font-semibold text-blue-600 underline dark:text-blue-400">featured games</a> and read about the history of each game.</p>
              <p>If you have requests, feedback, or bugs to report, you can get in touch via <a href="mailto:admin@gfal.co.uk" className="font-semibold text-blue-600 underline dark:text-blue-400">
                admin@gfal.co.uk
              </a>
              .
            </p>
          </div>
        </section>

         <section className="mt-6 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900 sm:p-8">
          <div className="max-w-3xl">
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-500 dark:text-slate-400">
              Feedback
            </p>
            <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
              Thanks for playing! Here's what people are saying...
            </h2>
            <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Below are some of the comments and feedback we've received from players. We love hearing from you, so please keep it coming!
            </p>
          </div>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Samantha, Ottawa</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">"I had so much fun playing with my family! The games are simple but really engaging."</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Jamie, London</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">"The variety of games is fantastic. There's something for everyone, and it's a great way to connect with friends."</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Kevin, Dunblane</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">"Location Tracker is amazing for Top Gear/Grand Tour style races across the UK!"</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Your comment here</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Any feedback can be sent to <a href="mailto:admin@gfal.co.uk?subject=GFAL Feedback" className="font-semibold text-blue-600 underline dark:text-blue-400">
                admin@gfal.co.uk
              </a></p>
            </div>
          </div>
        </section>

        <section className="mt-6 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-900 sm:p-8">
          <div className="max-w-3xl">
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-500 dark:text-slate-400">
              Attributions
            </p>
            <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
              Credits and sources
            </h2>
            <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Below are some of the asset and service sources used throughout the app.
            </p>
          </div>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <a href="https://heroicons.com/" target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 dark:hover:bg-slate-750">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Icons</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Heroicons MIT</p>
            </a>
            <a href="https://freesound.org/" target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 dark:hover:bg-slate-750">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Sound effects</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Freesound.org (various licenses)</p>
            </a>
            <a href="https://fonts.google.com/" target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 dark:hover:bg-slate-750">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Fonts</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Google Fonts</p>
            </a>
            <a href="https://www.deezer.com/" target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 dark:hover:bg-slate-750">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Music</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Deezer API</p>
            </a>
            <a href="https://commons.wikimedia.org/" target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 dark:hover:bg-slate-750">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">Reference imagery</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Wikimedia Commons</p>
            </a>
            <a href="https://github.com/features/copilot" target="_blank" rel="noopener noreferrer" className="rounded-2xl border border-slate-200 bg-slate-50 p-4 transition-colors hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600 dark:hover:bg-slate-750">
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">AI</p>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">Github Copilot</p>
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;